<template>
  <v-menu v-model="menu" :close-on-content-click="false" max-width="290">
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="_date"
        readonly
        color="primary"
        @input="onInput"
        v-on="on"
        v-bind="$attrs"
      />
    </template>
    <v-date-picker
      :value="_value"
      @input="onInput"
      locale="au"
      v-bind="$attrs"
    />
  </v-menu>
</template>

<script>
import { formatISO } from 'date-fns'
import { dateFilters } from '../../filters/date-filters'

export default {
  name: 'DateInput',

  props: {
    value: {
      type: [String, Number, Date]
    }
  },

  data: () => ({
    menu: false
  }),

  computed: {
    _value () {
      return this.value
        ? formatISO(new Date(this.value), { representation: 'date' })
        : null
    },
    _date () {
      return this.value
        ? dateFilters.formatDate(this.value)
        : null
    }
  },

  methods: {
    onInput (v) {
      this.$emit('input', v)
      this.menu = false
    }
  }
}
</script>
